import React, { Component } from 'react';
import './index.css';
import { Button, Spinner, Tooltip } from '@shopify/polaris';
import Language from '../../i18n/Language';
const t = Language;

/*
  SEO Score 仪表盘
 */
class InstrumentPanel extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isSpeed: this.props.isSpeed,
      svgHeight: this.props.svgHeight,
      strokeDashUse: 0,
      speedType: this.props.speedType || 'pc',
      strokeWidth: this.props.strokeWidth || 14,
      smallSize: this.props.smallSize || 0,
      bigSize: this.props.bigSize || 0,
      isShowRecheck: this.props.isShowRecheck || false,
      loading: this.props.loading || false,
      isPwd: this.props.isPwd || false,

    };
  }

  componentDidMount() {
    let { strokeDash } = this.props;
    this.setStrokeDash(strokeDash);
  }

  shouldComponentUpdate(nextProps) {
    if (nextProps.strokeDash !== this.props.strokeDash) {
      this.setStrokeDash(nextProps.strokeDash);
    }

    if (nextProps.loading !== this.props.loading) {
      this.setState({
        loading: nextProps.loading,
      })
    }

    if (nextProps.isPwd !== this.props.isPwd) {
      this.setState({
        isPwd: nextProps.isPwd,
      })
    }

    if (nextProps.speedType !== this.props.speedType) {
      this.setState({
        speedType: nextProps.speedType,
      })
    }

    return true;
  }

  // 设置分数
  setStrokeDash = (val) => {
    if (val >= 0) {
      this.setState({
        strokeDashUse: val,
      })
    }
  }

  render() {
    const {
      svgHeight,
      strokeDashUse,
      isSpeed,
      speedType,
      strokeWidth,
      smallSize,
      loading,
      isShowRecheck,
      isPwd,

    } = this.state;

    // 区间 判断主题色
    let strokeColorProd = "", strokeColorProdBg = ""; // 颜色
    let _score = this.props.strokeDash;
    if (loading) {
      strokeColorProdBg = "#f1f1f1";
      strokeColorProd = "#b8bfc4";
    } else {
      if (isSpeed) {
        // 速度分数 分类 pc+mobile
        if ((speedType === 'pc' && _score >= 85) || (speedType === 'mb' && _score >= 70)) {
          strokeColorProdBg = "#e5faef";
          strokeColorProd = "#27AE60";
        } else if ((speedType === 'pc' && _score >= 50 && _score <= 84) || (speedType === 'mb' && _score >= 40 && _score <= 69)) {
          strokeColorProdBg = "#fff6ea";
          strokeColorProd = "#F1930F";
        } else {
          strokeColorProdBg = "#ffeaea";
          strokeColorProd = "#D33430";
        }
      } else {
        if (_score > 66) {
          strokeColorProdBg = "#e5faef";
          strokeColorProd = "#27AE60";
        } else if (_score > 33 && _score <= 66) {
          strokeColorProdBg = "#fff6ea";
          strokeColorProd = "#F1930F";
        } else {
          strokeColorProdBg = "#ffeaea";
          strokeColorProd = "#D33430";
        }
      }
    }

    let svgHeightProd = svgHeight || 60; // 高度
    let strokeDashProd = strokeDashUse * 5 || 0; // 进度
    
    const panelCircle = <div className='panel_circle' style={{ height: `${svgHeightProd}px` }}>
      <div className='ps_sticky_btn' style={{ display: (isShowRecheck && !loading) ? 'block' : 'none' }}>
        {
          isPwd ? <Tooltip content={t("Your store requires a password to access.")}>
            <Button size='micro'>{t("Re-test")}</Button>
          </Tooltip> : <Button size='micro' onClick={this.props.onRecheck}>{t("Re-test")}</Button>
        }
      </div>
      <span>
        <svg viewBox="0 0 180 180" width="100%" height={svgHeightProd}>
          <circle strokeWidth="30" fill="none" cx="90" cy="90" r="80"></circle>
          <circle fill={strokeColorProdBg} cx="90" cy="90" r="86"></circle>
          <circle stroke={strokeColorProd} strokeWidth={strokeWidth} strokeDasharray={`${loading ? 36 : strokeDashProd}, 502.40000000000003`} strokeLinecap="round" fill="none" cx="90" cy="90" r="80" style={{
            transform: "rotate(-90deg)", transformOrigin: "center center", transition: "all 0.5s cubic-bezier(0.58, 0.16, 0.5, 1.14) 0.2s"
          }}></circle>
        </svg>
      </span>
      <div className='panel_value' style={{ height: `${svgHeightProd}px`, lineHeight: `${svgHeightProd}px`, fontSize: `${(svgHeightProd / 60) + 0.2 - smallSize}rem`, color: `${strokeColorProd}`, fontWeight: 700 }}>
        {
          loading ? <div className='panel_value' style={{ lineHeight: `135px` }}><Spinner size='small' /></div> : this.props.strokeDash
        }
      </div>
    </div>

    return panelCircle;
  }
}

export default InstrumentPanel;